<i18n lang="yaml" locale="en">
  text: Text
  file: File
  form: Form
  iframe: Iframe
  locale changer: Locale changer
</i18n>

<i18n lang="yaml" locale="de">
  text: Text
  file: Datei
  form: Formular
  iframe: Iframe
  locale changer: Sprachwechsler
</i18n>

<script>
import BaseModule from '@/components/modules/BaseModule'

export default {
  extends: BaseModule,
  childOptions: {
    html: 'text',
    file: 'file',
    form: 'form',
    iframe: 'iframe',
    localeChanger: 'locale changer'
  },
  inject: ['$grid', '$project'],
  provide () {
    return {
      $box: this
    }
  },
  props: {
    w: {
      type: Number,
      required: true
    },
    h: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      default: 0
    },
    x: {
      type: Number,
      default: 0
    }
  },
  computed: {
    gridActive () {
      return this.$grid && this.$grid.$parent && this.$grid.$parent.isActive
    },
    boxWidth () {
      return this.$props.w * this.$grid.boxWidth
    },
    boxHeight () {
      return this.$props.h * this.$grid.boxHeight
    },
    boxX () {
      return this.$props.x * this.$grid.boxWidth
    },
    boxY () {
      return this.$props.y * this.$grid.boxHeight
    },
    positionStyle () {
      return {
        width: this.boxWidth + 'px',
        height: this.boxHeight + 'px',
        left: this.boxX + 'px',
        top: this.boxY + 'px'
      }
    }
  }
}
</script>
